'use strict';
import Promise from 'bluebird';
import $ from 'jquery';

const API_URL = '/fi/api/v1/products';

export const getProduct = (productId, options = {}) =>
	Promise.resolve($.get(`${API_URL}/${productId}/`, options));
